import mystiqueVersion from '@jusbrasil/mystique/version'

const URL = `https://static.jusbr.com/mystique/${mystiqueVersion}/css/mystique.min.css`

export function MystiqueStylesheet() {
  return <link href={URL} rel="stylesheet" type="text/css" data-testid="css" />
}
